import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/price-down.svg";
var PriceDownOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PriceDownOutline_default as default
};
